module.exports = __webpack_public_path__ + "img/04-3-5多样化.9b0271b0.svg";